import React from 'react';
// import ReactDOM from 'react-dom';
// import {BACKEND_URL,} from "./urls";

export function sendRequestToLogging(body){
  return;
//   fetch(`${BACKEND_URL}/logging/add/`, {
//     headers: {
//         'Accept': 'application/json',
//         'Content-Type': 'application/json'
//     },
//     method: "POST",
//     body: body
// })

}

export default class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
    //   this.state = { error: null, errorInfo: null };
    }
    
    componentDidCatch(error, errorInfo) {      
      if (process.env.REACT_APP_ENVIRONMENT == "DEVELOPMENT" || process.env.REACT_APP_ENVIRONMENT == 'LOCALHOST'){
        console.error(error, errorInfo);
      }
      // else{
      //     sendRequestToLogging(JSON.stringify({ traceback : "error = " + error + " \n URL = " + (window.location.href) + "\ntraceback: \n" + errorInfo.componentStack}));
      //   // To see actual error in react js
      //   // 1)find the source map file with the below command
      //   //    ls build/static/js/ | grep "^\main\..*.map"
      //   // 2) Use stacktracify to get actually stacktrace e.g
      //   //    stacktracify build/static/js/2.7bd88b6e.chunk.js.map --file stacktrace.txt

      // }
    }
    
    render() {
    //   if (this.state.errorInfo) {
    //     // Error path
    //     return (
    //       <div>
    //         <h2>Something went wrong.</h2>
    //         <details style={{ whiteSpace: 'pre-wrap' }}>
    //           {this.state.error && this.state.error.toString()}
    //           <br />
    //           {this.state.errorInfo.componentStack}
    //         </details>
    //       </div>
    //     );
    //   }
      // Normally, just render children
      return this.props.children;
    }  
  }
  